/**
 * StatusSmsCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {StatusSms} from '@/model/resource/StatusSms'

/* TODO: review generated class */
@HttpExclude()
export class StatusSmsCollection extends PageCollection<StatusSms> {
  constructor() {
    super(StatusSms)
  }

  queryAsPage() {
    return this.listStatusSms()
  }

  async listStatusSms() {
    return await Request.get(`/admin/status-sms`, {params: this.params})
      .name('listStatusSms')
      .as(this)
      .getResponse()
  }

  async listCsvStatusSms() {
    return await Request.get(`/admin/status-sms/csv`, {params: this.params})
      .name('listCsvStatusSms')
      .as(this)
      .getResponse()
  }
}
